import styled from 'styled-components';

export default styled.div`
  color: ${(p) => p.theme.formLabelColor};
  font-size: 13px;
  font-weight: bold;
  line-height: 17px;
  margin-bottom: 4px;

  @media (max-width: 720px) {
    margin-top: 10px;
  }
`;
